import { QueryClient } from "@tanstack/react-query";

export type BasicMutationOptions<DataT, ErrorT> = {
  onSuccess?: (data: DataT) => void;
  onError?: (error: ErrorT) => void;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      // Bez staleTime każdy mount komponentu refetchował te same dane
      // (procedury, tenant, listy) przy zwykłej nawigacji. 30 s to krótko
      // wobec tempa zmian danych w aplikacji; invalidateQueries po
      // mutacjach i tak wymusza natychmiastowy refetch.
      staleTime: 30_000,
    },
  },
});

export default queryClient;
